import Vue from 'vue'

export default {
  getSalesDetails (id) {
    return Vue.http.get(`/reports/${id}/sales_details`)
  },

  getMachineTransactions (machineId, limit, page) {
    return Vue.http.get(`/transactions`, {
      params: {
        franchisee_machine_id: machineId,
        limit,
        page
      }
    })
  }
}
